import React from 'react';
import VideoPlayer from '../../Global/VideoPlayer/VideoPlayer';
import MuxPlayer from '@mux/mux-player-react';

import './styles.scss';

const ManualVideo = ({ block }) => {
  const { file, internalVideo } = block;

  if (!file && !internalVideo) {
    console.warn('No video found');
    return null;
  }

  if (file) {
    return <VideoPlayer video={file} />;
  }

  const {
    video: { muxPlaybackId },
  } = internalVideo;

  return (
    <div className="manual-video-block">
      <MuxPlayer playbackId={muxPlaybackId} />
    </div>
  );
};

export default ManualVideo;
